import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo-win.svg";
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import { useNavigate, useLocation } from 'react-router-dom';
import ErrorModal from "../Security/ErrorModal";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const WinBenefitOptions = () => {
  const { t, i18n } = useTranslation();
  const [benefitProvider, setBenefitProvider] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [combinedProviderData, setCombinedProviderData] = useState({});
  const ssoData = useSelector((state) => state.sso.ssoUserData); // Get full SSO user data
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [logo, setLogo] = useState(null);
  const location = useLocation();
  const { currentStep = 3, totalSteps = 4 } = location.state || {};
  const InActiveMemberData = location?.state?.InActiveMemberData;
  const otherData = location?.state?.otherData;
const fromLogin = useSelector(state => state.fromLogin.fromLogin);
  const navigate = useNavigate();
  const [formData2, setForm2Data] = useState({
    dateOfBirth: "",
    phoneNumber: "",
    agreeToTexts: false,
    country: "",
    zipCode: "",
    language: "",
    raceEthnicity: "",
  });
  const [form1Data, setFormData1] = useState({
    firstName: "",
    lastName: "",
    preferredName: "",
    email: "",
    password: "",
    confirmPassword: "",
    agreeTerms: false,
  });


  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);


  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

   // Get the passed state (combinedFormData) from the previous component
   useEffect(() => {
   if(location.state?.form4Data){
    setBenefitProvider(location.state?.form4Data?.BenefitProvider || "");
    setCombinedProviderData(location.state.form4Data)
    return;
   }
   if (location.state?.form3Data && location.state?.combinedFormData) 
    {
    setBenefitProvider(location.state?.form3Data);
    setCombinedProviderData(location.state.combinedFormData);
    return;
    }
       if (location.state?.form3Data && location.state?.InActiveMemberData) 
    {
    setBenefitProvider(location.state?.form3Data);
    setCombinedProviderData(location.state?.InActiveMemberData);
    return;
    }
    else if(location.state?.combinedFormData){
      setCombinedProviderData(location.state?.combinedFormData);
      setBenefitProvider(location.state?.combinedFormData?.BenefitProvider || "");
    }
  
  }, [location.state]);

  const handleOptionChange = (e) => {
    setBenefitProvider(e.target.value);
    setErrorMessage("");
  };
  const handleBack = () => {
    if(fromLogin) {
      navigate("/login");
    }
    else{
    const form2Data = {
      dateOfBirth: combinedProviderData.DOB,
      phoneNumber: combinedProviderData.PhoneNo,
      agreeToTexts: combinedProviderData.TextNotificationStatus === "Yes",
      country: combinedProviderData.Country,
      zipCode: combinedProviderData.ZipCode,
      language: combinedProviderData.Language,
      raceEthnicity: combinedProviderData.Ethnicity,
    };
  
    const formData1 = {
      firstName: combinedProviderData.FirstName,
      lastName: combinedProviderData.LastName,
      preferredName: combinedProviderData.PreferredName,
      email: combinedProviderData.EmailID,
      password: combinedProviderData.PWD,
      confirmPassword: combinedProviderData.ConfirmPassword,
      agreeTerms: combinedProviderData.AgreeTerms,
    };
    setForm2Data(form2Data);
    setFormData1(formData1)
    navigate("/registration-form-two", { state: { formData1, form2Data, form3Data:benefitProvider , otherData:{...otherData} } });
  }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    // Add the access code to the combinedFormData's PromoCode field
    if (fromLogin) {
      updatedProviderData = {
    BenefitProvider: benefitProvider ,
    MemberID: "",
    FirstName: InActiveMemberData.FirstName || "",
    LastName: InActiveMemberData.LastName || "",
    DOB: InActiveMemberData.DOB || "",
    EmailID: InActiveMemberData.EmailID || "",
    PreferredName: InActiveMemberData.PreferredName || "",
    Ethnicity: InActiveMemberData.Ethnicity || "",
    Gender: InActiveMemberData.Gender || "",
    Pronouns: InActiveMemberData.Pronouns || "",
    RelationshipStatus: InActiveMemberData.RelationshipStatus || "",
    PhoneNo: InActiveMemberData.PhoneNumber || InActiveMemberData.MobileNumber || "",
    ZipCode: InActiveMemberData.ZipCode || "",
    Language: InActiveMemberData.Language || "English",
    TextNotificationStatus: InActiveMemberData.TextNotificationStatus || "No",
    WINBenefits: InActiveMemberData.WINBenefits || "N",
    SecureCode: InActiveMemberData.SecureCode || "",
    Country: InActiveMemberData.Country || "",
    CountryCode: InActiveMemberData.CountryCode || "",
    AppLanguage: InActiveMemberData.AppLanguage || "English",
    Goal: InActiveMemberData.Goal || "",
WhyHere: InActiveMemberData.WhyHere || "",
Company: InActiveMemberData.Company || "",
Promocode: InActiveMemberData.Promocode || "",
PWD: InActiveMemberData.PWD || "",
SubscriberID: InActiveMemberData.SubscriberID || "",
HealthPlanId: InActiveMemberData.HealthPlanId || "",
JourneyStatus: InActiveMemberData.JourneyStatus || "",
PregnancyDueDate: InActiveMemberData.PregnancyDueDate || "",
Height: InActiveMemberData.Height || "",
TypeofHeight: InActiveMemberData.TypeofHeight || "",
Weight: InActiveMemberData.Weight || "",
TypeofWeigh: InActiveMemberData.TypeofWeigh || "",
LastMenstrualPeriodDate: InActiveMemberData.LastMenstrualPeriodDate || "",
IsPregnent: InActiveMemberData.IsPregnent || "",
NoDueDateFlag: InActiveMemberData.NoDueDateFlag || "",
WinCentivekit: InActiveMemberData.WinCentivekit || "",
WinCentiveAddress: InActiveMemberData.WinCentiveAddress || "",
    Version: "1.0",
    DeviceType: "PatientPortal",
    UpdateFlag: "Y",
    IsHealthProfileCompleted: 1,
    Contract : ""
  };
    }
      else
      {
     var updatedProviderData = {
      ...combinedProviderData,
      BenefitProvider: benefitProvider, // Set access code to Promocode
    };
      }
    

    // Ensure an option is selected
    if (benefitProvider === "") {
      // setModalMessage("Please select a benefit provider");
      // setShowModal(true);
      setErrorMessage("Please select a benefit provider");
      return;
    }
    const navigatingFromBenefitOptions = true;
          // Navigate based on the selected benefit provider
          if (combinedProviderData.Country === "United Kingdom" && benefitProvider === "I'm paying for myself") {
            navigate('/patientconsent-form', { state: { updatedFormData: updatedProviderData, otherData: { ...otherData, navigatingFromBenefitOptions } } });
          } else if (combinedProviderData.Country !== "United Kingdom" && benefitProvider === "I'm paying for myself") {
            navigate('/contact', { state: { updatedFormData: updatedProviderData, otherData: { ...otherData, navigatingFromBenefitOptions } } });
          } else {
            navigate('/accesscode', { state: updatedProviderData });
          }
  };

  return (
    <>
    {/* <div> <LanguageSelector /></div> */}
      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
          {isHighmarkPortal ? 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          }            
          </a>
        </nav>
      </header>

      <div className="registration-block-main">
        {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}

        {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">
          <form>
            <h3 className="page-heading-secondary-black mb-5">{t('providesyourwinbenefit')}</h3>
            {/* <h3 className="page-heading-bold">Username</h3> */}
            <div className="mb-3 mt-5 form-check multi-step-form-rdb-chekcbox-wrapper">
                      <input
                        type="radio"
                        class="form-check-input radio-btn win-form-check-input"
                        id="employer"
                        value="My employer"
                        checked={benefitProvider === "My employer"}
                        onChange={handleOptionChange}
                      />
                      <label for="employer"
                        className="multistep-form-radio-checkbox-label"
                      > {t('myemployeer')}
                      </label>
                    </div>

                    <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                      <input
                        type="radio"
                        class="form-check-input radio-btn win-form-check-input"
                        id="partner"
                        value="My partner or someone else"
                        checked={benefitProvider === "My partner or someone else"}
                        onChange={handleOptionChange}
                      />
                      <label for="partner"
                        className="multistep-form-radio-checkbox-label"
                      > {t('mypartnerorsomeoneelse')}
                      </label>
                    </div>

                    <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                      <input
                        type="radio"
                        class="form-check-input radio-btn win-form-check-input"
                        id="self"
                        value="I'm paying for myself"
                        checked={benefitProvider === "I'm paying for myself"}
                        onChange={handleOptionChange}
                      />
                      <label for="self"
                        className="multistep-form-radio-checkbox-label"
                      > {t('myself')}
                      </label>
                    </div>
                    {errorMessage && (
                <div className="form-field-error-message text-danger">
                  {errorMessage}
                </div>
              )}
                <div className="mb-3 mt-5">
                {isHighmarkPortal ? (
                      <>
                      <div className="pagination-wrapper mt-5">
                        <button className="previous-btn" onClick={handleBack} type="button"></button>                   
                        <span className="me-3">{currentStep} of {totalSteps}</span>
                        <button className="next-btn" onClick={handleSubmit} type="button"></button>
                      </div>
                      </>
                    ) : (
                      <>
                  <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={handleBack}>{t('back')}</button>
                  <button className="win-btn-primary mobile-view" onClick={handleSubmit} type="button">
                  {t('nextbutton')}
                  </button>
                  </>
                    )}
            </div>
          </form>
          </div>
        </div>
        {/* registration right form area end */}
        <ErrorModal show={showModal} message={modalMessage} onClose={() => setShowModal(false)} />
      </div>        
    </>
  );
};
export default WinBenefitOptions;
